<div class="root">
  <div class="filter-bar">
    <div>
      <div>{{ 'label.TransactionCode' | translate }}</div>
      <div>
        <input
          type="text"
          [(ngModel)]="filterPagingWrapper.filter.transactionCode"
        />
      </div>
    </div>
    <div>
      <div>{{ 'label.InvoiceCode' | translate }}</div>
      <div>
        <input
          type="text"
          [(ngModel)]="filterPagingWrapper.filter.invoiceCode"
        />
      </div>
    </div>
    <div>
      <div>{{ 'label.CustomerCredential' | translate }}</div>
      <div>
        <input
          type="text"
          [(ngModel)]="filterPagingWrapper.filter.customerCredential"
        />
      </div>
    </div>
    <div *ngIf="hasViewAllInvoicesPermission">
      <div>{{ 'label.AccountManager' | translate }}</div>
      <div>
        <select
          [ngModel]="
            accountManagers && filterPagingWrapper.filter.accountManagerId
          "
          (ngModelChange)="
            accountManagers &&
              (filterPagingWrapper.filter.accountManagerId = $event)
          "
        >
          <option selected></option>
          <option *ngFor="let item of accountManagers" [value]="item?.adminId">
            {{ item?.fullName }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <div>{{ 'label.Status' | translate }}</div>
      <div>
        <select [(ngModel)]="filterPagingWrapper.filter.invoiceStatus">
          <option selected></option>
          <option *ngFor="let item of invoiceStatuses" [value]="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="c-date-picker">
      <div>{{ 'label.Dates' | translate }}:</div>
      <hr-date-range-picker
        class="date-picker"
        [dateFormat]="specialDateFormat"
        [style]="{ width: '100%', 'min-width': '5em' }"
        [(ngModel)]="filterPagingWrapper.filter.activationDate"
      ></hr-date-range-picker>
    </div>
    <br />
    <div>
      <p-checkbox
        [(ngModel)]="filterPagingWrapper.filter.mismatched"
        binary="true"
        inputId="chk-mismatched"
      ></p-checkbox>
      ({{ mismatchesCount }})
      <label for="chk-mismatched">{{ 'label.Mismatches' | translate }}</label>
    </div>
    <br />
    <div>
      <button class="apply" (click)="onApplyFilter()">
        {{ 'label.Filter' | translate }}
      </button>
      <button class="clear" (click)="onClearFilter()">
        {{ 'label.Clear' | translate }}
      </button>
    </div>
  </div>
  <div class="invoices-table">
    <div style="padding-bottom: 5px">
      <button
        [disabled]="
          !hasInvoiceMergeUnmergePermission || selectedInvoices.length <= 1
        "
        (click)="onInvoiceMerge()"
      >
        {{ 'label.MergeInvoice' | translate }}
      </button>
      <button
        [disabled]="
          !hasInvoiceMergeUnmergePermission || selectedInvoices.length != 1
        "
        (click)="onInvoiceUnmerge()"
      >
        {{ 'label.UnMergeInvoice' | translate }}
      </button>
      <p-button
        type="button"
        class="ui-button-secondary"
        [disabled]="!isSendInvoiceAvailable()"
        (click)="onSendInvoiceClick()"
        [ngStyle]="{ 'margin-left': '10%' }"
        icon="fa fa-envelope"
        label="{{ 'label.SendInvoiceEmail' | translate }}"
      ></p-button>
      <button
        [disabled]="!hasInvoiceApprovePermission || selectedInvoices.length < 1"
        style="float: right"
        (click)="onInvoiceApprove()"
      >
        {{ 'label.Approve' | translate }}
      </button>
    </div>
    <hr-send-invoice-dialog
      *ngIf="trySendInvoice"
      [invoices]="getSelectedInvoiceIds()"
      (onUpdate)="onUpdateTable($event)"
    ></hr-send-invoice-dialog>
    <p-table
      [value]="invoices"
      [(selection)]="selectedInvoices"
      showGridlines
      [lazy]="true"
      [paginator]="true"
      [rows]="pageSize"
      (onLazyLoad)="onLoad($event)"
      [totalRecords]="totalRecords"
      dataKey="invoiceId"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3em">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th [pSortableColumn]="'invoiceCode'" style="width: 150px">
            {{ 'label.InvoiceCode' | translate }}
            <p-sortIcon
              [field]="'invoiceCode'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th [pSortableColumn]="'activationDate'" style="width: 120px">
            {{ 'label.Date' | translate }}
            <p-sortIcon
              [field]="'activationDate'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th [pSortableColumn]="'payer'" style="width: 10%">
            {{ 'label.Payer' | translate }}
            <p-sortIcon
              [field]="'payer'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th style="width: 10%">
            {{ 'label.AccountManager' | translate }}
          </th>
          <th style="width: 10%">
            {{ 'label.TransactionCode' | translate }}
          </th>
          <th>
            {{ 'label.TransactionContent' | translate }}
          </th>

          <th [pSortableColumn]="'invoiceTotal'" style="width: 100px">
            {{ 'label.InvoiceAmount' | translate }}
            <p-sortIcon
              [field]="'invoiceTotal'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th [pSortableColumn]="'status'" style="width: 120px">
            {{ 'label.Status' | translate }}
            <p-sortIcon
              [field]="'status'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th [pSortableColumn]="'approval'" style="width: 150px">
            {{ 'label.Approval' | translate }}
            <p-sortIcon
              [field]="'approval'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th [pSortableColumn]="'accounting'" style="width: 120px">
            {{ 'label.AccountingStatus_invoices' | translate }}
            <p-sortIcon
              [field]="'accounting'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-invoice
        let-expanded="expanded"
        let-columns="columns"
      >
        <tr [pSelectableRow]="invoice" [ngClass]="getRowStyleClass(invoice)">
          <td>
            <p-tableCheckbox [value]="invoice"></p-tableCheckbox>
          </td>
          <td>
            <a
              *ngIf="invoice.invoiceFileId"
              href="{{ invoice.invoiceFileId }}"
              target="_blank"
              >{{ invoice.code }}</a
            >
            <span *ngIf="!invoice.invoiceFileId">{{ invoice.code }}</span>
          </td>
          <td>
            <input
              [disabled]="
                !hasEditInvoicePermission ||
                invoice.invoiceTypeId == InvoiceType.DebitCorrection
              "
              [ngModel]="invoice.activationDate | date : 'yyyy-MM-dd'"
              (ngModelChange)="updateInvoiceDate(invoice, $event)"
              type="date"
              required="required"
            />
            <div class="date">
              <i
                *ngIf="invoice.isSent"
                class="fa fa-envelope invoice-sent"
                aria-hidden="true"
              ></i>
              <span class="date-tooltip">{{
                invoice.sendDate | date : dateFormat
              }}</span>
            </div>
          </td>
          <td>
            <span
              ><a [routerLink]="['/customers/view', invoice?.customerId]">{{
                invoice.payerName
              }}</a></span
            ><br />
            <span>{{ invoice.payerTaxId }}</span
            ><br />
            <span>{{ invoice.payerVatStatusName }}</span>
          </td>
          <td>
            <p *ngFor="let managerName of invoice.accountManagerFullNames">
              {{ managerName }}
            </p>
          </td>
          <td>
            <a
              *ngFor="let code of invoice.transactionCodes"
              [routerLink]="['/billing/transactions/list', code]"
              >{{ code }}
            </a>
          </td>
          <td>
            <span [innerHTML]="invoice.getInvoiceContent()"></span>
          </td>
          <td>
            <span>{{ invoice.totalAmount }}</span>
          </td>
          <td>
            <p>{{ invoice.statusName }}</p>
            <a
              *ngFor="let paymentCode of invoice.paymentCodes"
              [routerLink]="['/billing/payments/list', paymentCode]"
              >{{ paymentCode }}
            </a>
          </td>
          <td>
            <span *ngIf="invoice.isApproved">{{
              'label.Approved_invoices' | translate
            }}</span>
            <span *ngIf="!invoice.isApproved">{{
              'label.NotApproved_invoices' | translate
            }}</span>
          </td>
          <td>
            <select
              [(ngModel)]="invoice.accountingStatusId"
              (ngModelChange)="onAccountingStatusChange(invoice, $event)"
              [disabled]="!hasEditInvoiceAccountingPermission"
            >
              <option
                *ngFor="let item of invoiceAccountingStatuses"
                [ngValue]="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer" let-columns>
        <tr>
          <td>{{ totalRecords }}</td>
          <td colspan="6"></td>
          <td>{{ invoicesTotal }}</td>
          <td colspan="3"></td>
        </tr>
      </ng-template>

      <!-- <p-column [style]="{'width':'38px'}" selectionMode="multiple"></p-column>
            <p-column header="{{'label.InvoiceCode' | translate}}" field="invoiceCode" [sortable]="true" [style]="{'width':'100px'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <a *ngIf="invoice.invoiceFileId" href="{{invoice.invoiceFileId}}" target="_blank">{{invoice.code}}</a>
                <span *ngIf="!invoice.invoiceFileId">{{invoice.code}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Date' | translate}}" field="activationDate" [sortable]="true" [style]="{'width':'120px'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <input [disabled]="!hasEditInvoicePermission || invoice.invoiceTypeId == InvoiceType.DebitCorrection" [ngModel]="invoice.activationDate | date:'yyyy-MM-dd'" (ngModelChange)="updateInvoiceDate(invoice, $event)" type="date" required="required" />
                <div class="date">
                    <i *ngIf="invoice.isSent" class="fa fa-envelope invoice-sent" aria-hidden="true"></i>
                    <span class="date-tooltip">{{invoice.sendDate | date:dateFormat}}</span>
                </div>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Payer' | translate}}" field="payer" [sortable]="true" [style]="{'width':'10%'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <span><a [routerLink]="['/customers/view', invoice?.customerId]">{{invoice.payerName}}</a></span><br>
                <span>{{invoice.payerTaxId}}</span><br>
                <span>{{invoice.payerVatStatusName}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.AccountManager' | translate}}" [style]="{'width':'10%'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <p *ngFor="let managerName of invoice.accountManagerFullNames">{{managerName}}</p>
            </ng-template>
            </p-column>
            <p-column header="{{'label.TransactionCode' | translate}}"  [style]="{'width':'10%'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <a *ngFor="let code of invoice.transactionCodes" [routerLink]="['/billing/transactions/list', code]">{{code}} </a>
            </ng-template>
            </p-column>
            <p-column header="{{'label.TransactionContent' | translate}}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <span [innerHTML]="invoice.getInvoiceContent()"></span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.InvoiceAmount' | translate}}" field="invoiceTotal" [sortable]="true" [style]="{'width':'70px'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <span>{{invoice.totalAmount}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Status' | translate}}" field="status" [sortable]="true" [style]="{'width':'100px'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <p>{{invoice.statusName}}</p>
                <a *ngFor="let paymentCode of invoice.paymentCodes" [routerLink]="['/billing/payments/list', paymentCode]">{{paymentCode}} </a>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Approval' | translate}}" field="approval" [sortable]="true" [style]="{'width':'100px'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <span *ngIf="invoice.isApproved">{{'label.Approved_invoices' | translate}}</span>
                <span *ngIf="!invoice.isApproved">{{'label.NotApproved_invoices' | translate}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.AccountingStatus_invoices' | translate}}" field="accounting" [sortable]="true" [style]="{'width':'100px'}">
            <ng-template let-col let-invoice="rowData" pTemplate="body">
                <select [(ngModel)]="invoice.accountingStatusId" (ngModelChange)="onAccountingStatusChange(invoice, $event)" [disabled]="!hasEditInvoiceAccountingPermission">
                    <option *ngFor="let item of invoiceAccountingStatuses" [value]="item.value">{{item.label}} </option>
                </select>
            </ng-template>
            </p-column>
            <p-footerColumnGroup>
                <p-row>
                    <p-column footer="{{totalRecords}}"></p-column>
                    <p-column colspan="6"></p-column>
                    <p-column footer="{{invoicesTotal}}"></p-column>
                    <p-column colspan="3"></p-column>
                </p-row>
            </p-footerColumnGroup> -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="11">
            {{ 'message.NoRecordsFound' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
